export enum QuotaUsageRateEnum {
    INACTIVE = 'INACTIVE',
    SAFE_USAGE = 'SAFE_USAGE',
    HIGH_USAGE = 'HIGH_USAGE',
    EXCESSIVE_USAGE = 'EXCESSIVE_USAGE'
}
